import { Component, OnInit, Input} from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import * as moment from 'moment';
import * as firebase from 'firebase';

@Component({
  selector: 'app-reply-form',
  templateUrl: './reply-form.component.html',
  styleUrls: ['./reply-form.component.scss'],
  providers: [
    AngularFireDatabase,
    AngularFireAuth
  ]
})
export class ReplyFormComponent implements OnInit {

  @Input() forum;
  @Input() forumId;

  repliesRef : any;
  reply: any = {};
  user : any;
  profile : any = {
    avatarUrl: 'https://chispa-rural.firebaseapp.com/assets/img/avatar.png',
  }
  attachmentFile : any;
  attachmentImg : any;
  attachmentUrl : any;
  pdfName : any;

  constructor(private db: AngularFireDatabase, private afAuth: AngularFireAuth) {

  }

  ngOnInit() {
    this.repliesRef = this.db.list('replies/');
    this.afAuth.auth.onAuthStateChanged(user => {
      this.user = user;

      const subscription = this.db.object(`profiles/${this.user.uid}`)
      .valueChanges().subscribe(snapshot => {
        subscription.unsubscribe();
        Object.assign(this.profile, snapshot);
      })
    })

    this.expandTextarea('message');
  }

  sendReply() {
    this.reply.created_at = moment().format('YYYY-MM-DD HH:mm:ss');
    this.reply.userId = this.user.uid;
    this.reply.userName = this.user.displayName;
    this.reply.forumId = this.forumId;
    this.reply.attachmentURL = this.attachmentUrl? this.attachmentUrl : null;

    this.repliesRef.push(this.reply)
      .then(result => {
        this.reply = {};
      });

    this.clear();
  }

  uploadFile(files, type) {
    let storageRef = firebase.storage().ref();
    let success = false;

    let selectedFile = files.srcElement.files[0];
    let path = `/attachments/${selectedFile.name}`;
    let fileRef = storageRef.child(path);

    fileRef.put(selectedFile).then((snapshot) => {
      if (type === 0) {
        this.attachmentFile = null;
        this.attachmentImg = snapshot.metadata.downloadURLs[0];
        this.attachmentUrl = this.attachmentImg
      } else {
        this.attachmentImg = null;
        this.attachmentFile = snapshot.metadata.downloadURLs[0];
        this.attachmentUrl = this.attachmentFile
        this.pdfName = snapshot.metadata.name;
      }
    });
  }

  expandTextarea(id) {
    document.getElementById(id).addEventListener('keypress', function() {
      this.style.height = this.scrollHeight + 'px';
    });
  }

  clear() {
    this.attachmentImg = null;
    this.attachmentUrl = null;
    this.attachmentFile = null;
    this.pdfName = null;
  }
}



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/replies/reply-form/reply-form.component.ts